import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=3a3a7a0e"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"
import style0 from "./Policies.vue?vue&type=style&index=0&id=3a3a7a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports